import React from 'react';
import { useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import ENUMS from '../../../../enums';
import useSetState from '../../../../hooks/useSetState';
import '../list/list-item/style.scss';
import { updateReservationHourStatusAtSchematics } from '../../../../redux/reserveTimes/actions';
import { fetchIncominSchematicReservation } from '../../../../redux/reservations/actions';
import { useDispatch } from 'react-redux';

const HandelTableTimeStatus = ({ ...props }) => {
  let dispatch = useDispatch();

  const [controls, setControls] = useSetState({
    status: '',
    TimeId: '',
    cafeTableId: '',
    toTime: '',
    fromTime: '',
  });

  const onChangeValue = (controleName, value) => {
    setControls({ [controleName]: value });
  };

  const handleStatusChange = event => {
    event.preventDefault();
    let updateObject = {
      id: controls.timeId,
      cafeTableId: props.table.cafeTableId,
      fromTime: controls.fromTime,
      toTime: controls.toTime,
      status: controls.status,
    };

    props.table.tableTimeStatus === 'WAITING_FOR_CAFE_RESPONSE'
      ? props.close(event)
      : dispatch(updateReservationHourStatusAtSchematics(updateObject)).then(
          () => {
            props.close(event);
            dispatch(
              fetchIncominSchematicReservation(
                window.localStorage.getItem('shematic-date'),
              ),
            );
          },
        );
  };

  useEffect(() => {
    onChangeValue('status', props.table.tableTimeStatus);
    onChangeValue('timeId', props.timeId);
    onChangeValue('cafeTableId', props.table.id);
    onChangeValue('fromTime', props.fromTime);
    onChangeValue('toTime', props.toTime);
  }, [props.isOpen]);

  return (
    <Modal isOpen={props.isOpen} size='lg'>
      <ModalHeader className='my-2'>
        <span>{locales('table.status')}</span>
        <span
          title={locales('labels.close.modal')}
          className='modal-close'
          onClick={event => props.close(event)}
        >
          close
        </span>
      </ModalHeader>

      <ModalBody>
        <div className=''>
          <label className='px-2 font-weight-bold'>
            {locales('titles.table')} :{' '}
          </label>
          <label className='px-2'>{props.table.num}</label>
          <label className='px-2 font-weight-bold'>
            {locales('labels.hour')} :{' '}
          </label>
          <label
            className='px-2'
            dir='ltr'
          >{`${props.fromTime} - ${props.toTime}`}</label>
        </div>

        {props.table.tableTimeStatus === 'WAITING_FOR_CAFE_RESPONSE' ? (
          <div className='font-weight-bold py-3'>
            {locales('this.table.is.being.booked.by.the.customer')}
          </div>
        ) : (
          <div className='d-flex justify-content-center'>
            {ENUMS.CAFE_RESERVATION_HOURS.list.slice(0, 2).map(status => (
              <div className='my-2 w-50'>
                <label className='px-2'>{status.title}</label>
                <input
                  type='radio'
                  className='cursorPointer'
                  value={status.value}
                  checked={controls.status === status.value}
                  onChange={() => onChangeValue('status', status.value)}
                />
              </div>
            ))}
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        <button
          onClick={event => handleStatusChange(event)}
          className='bg-success text-white border-0 w-100 py-2'
        >
          {locales('tables.approve')}
        </button>
      </ModalFooter>
    </Modal>
  );
};

export default HandelTableTimeStatus;
